import React, { useEffect, useState } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { injectIntl } from '../../util/reactIntl';
import { Page, UserNav, Footer, LayoutSideNavigation } from '../../components';
import css from './StipeSubscriptionPage.module.css';
import { withRouter } from 'react-router-dom';
import { withViewport } from '../../util/uiHelpers';
import { compose } from 'redux';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterComponent from '../FooterContainer/FooterContainer';
import StripeSubscriptionCard from '../../components/StripeSubscriptionPanel/StripeSubscriptionCard';
import { createSubscription, getSubscriptionData } from '../../containers/StripeSubscriptionPage/StripeSubscriptionPage.duck';
import SkeletonLoader from '../../components/SkeletonLoader/SkeletonLoader';
import { getStripeCustomerId, getUserDetails, userSubscriptions } from '../../util/helper';

import { types as sdkTypes } from '../../util/sdkLoader';
import { contactUsMessage, getSubscriptionStatusFromStripe } from '../../util/api';
const { UUID } = sdkTypes;

export const StripeSubscriptionPageComponent = props => {
  const { intl, history, getStatusData } = props;
  const state = useSelector(state => state);
  const [isSendMail, setIsSendMail] = useState(false);
  const [cardPaymentModal, setCardPaymentModal] = useState(false);
  const {
    subscriptionPlan,
    fetchPriceInProgress,
    createSubscriptionInProgress,
  } = state?.StripeSubscriptionPage;
  const { currentUser = null } = state.user;
  const { firstName, lastName } = currentUser?.attributes?.profile || {};
  const { email } = currentUser?.attributes || {};
  const fullName = firstName + ' ' + lastName;
  const dispatch = useDispatch();
  const userName = !!currentUser?.id && getUserDetails(currentUser)?.fullName;
  const onlineSubscriptionData = getStatusData|| [];
 
  // HandleSubscription
  const handleSubscription = async (e, price) => {
    const stripeCustomerId = currentUser?.stripeCustomer?.attributes?.stripeCustomerId;
    const customerId = currentUser?.id?.uuid;

    e && e.preventDefault();
    const params = {
      priceID: price?.id,
      stripeCustomerId: stripeCustomerId,
      customerId: customerId,
    };

    const response = await dispatch(createSubscription(params));
   
    if (response.success) {
      contactUsMessage({
        fullName: fullName,
        customerId: email,
        senderId: 'info@myfindor.com',
        subject: 'Congratulations on Becoming a Pro Star!',
        text: 'text',
        subscriptionEmail: 'subscription msg',
      }).then(
        res => {
          setIsSendMail(true);
          setTimeout(() => {
            setIsSendMail(false);
          }, 3000);
        },
        error => {
          console.error(error);
          if (error) {
            console.error(error);
          }
        }
      );
    }
  };

  const title = intl.formatMessage({ id: 'StripeSubscriptionPage.title' });
  return (
    <Page title={title}>
      <LayoutSideNavigation
        className={css.stripeSubscriptionWrapper}
        topbar={
          <>
            <TopbarContainer
              currentPage="StripeSubscriptionPage"
              desktopClassName={css.desktopTopbar}
              mobileClassName={css.mobileTopbar}
            />
            <UserNav currentPage="StripeSubscriptionPage" />
          </>
        }
        sideNav={null}
        useAccountSettingsNav
        currentPage="StripeSubscriptionPage"
        footer={<FooterComponent />}
      >
        <div className={css.stripeSubscriptionPanel}>
          {fetchPriceInProgress ? (
            <div className={css.skeletonLoader}>
              {[...Array(1)].map((_, index) => (
                <SkeletonLoader key={index} />
              ))}
            </div>
          ) : (
            <>
              {isSendMail ? (
                <div className={css.successMessage}>Subscription purchased successfully</div>
              ) : null}
              <StripeSubscriptionCard
                handleSubscription={handleSubscription}
                currentUser={currentUser}
                history={history}
                userName={userName}
                onlineSubscriptionData={onlineSubscriptionData}
                subscriptionPlan={subscriptionPlan}
                createSubscriptionInProgress={createSubscriptionInProgress}
                cardPaymentModal={cardPaymentModal}
                setCardPaymentModal={setCardPaymentModal}
              />
            </>
          )}
        </div>
      </LayoutSideNavigation>
    </Page>
  );
};

StripeSubscriptionPageComponent.defaultProps = {
  currentUser: null,
};

StripeSubscriptionPageComponent.propTypes = {};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const {
    getStatusData,
    getStatusDataInProgress,
    getStatusDataError,
  } = state.StripeSubscriptionPage;

  return {
    currentUser,
    getStatusData,
    getStatusDataInProgress,
    getStatusDataError,
  };
};

const StripeSubscriptionPage = compose(
  connect(mapStateToProps),
  injectIntl
)(StripeSubscriptionPageComponent);
export default StripeSubscriptionPage;
